import(/* webpackMode: "eager" */ "/vercel/path0/clientV2/src/app/global-error.tsx")